import React from "react";

// consistent, larger section heading used across the My Firm and My Profile pages
const SectionHeading = ({ children, style, divider }) => (
	<h3
		style={{
			fontSize: 20,
			marginTop: 0,
			marginBottom: 8,
			paddingBottom: divider ? 8 : 0,
			borderBottom: divider ? "1px solid var(--lw-light-grey-c)" : "none",
			...style,
		}}
	>
		{children}
	</h3>
);

export default SectionHeading;
